import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {
  @Input() feature: any;
  @Input() maxImageSize: number;
  @Input() maxChars: number = 10000;
  @Output() featureChange = new EventEmitter<any>();

  currentChars: number = 0;
  quillConfiguration = {
    toolbar: [
      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      ['bold', 'italic', 'underline', 'strike'],  
      [{ 'align': [] }],      // toggled buttons
      ['blockquote', 'code-block'],
      ['link' ],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      ['clean']                                         // remove formatting button
    ]
  };

  editorContent: string = '';


  logContent() {
    console.log(this.editorContent);
  }
  constructor(private messageService: MessageService) {}

  ngOnInit() {
    this.updateCharCount();
    if(!this.feature.value)
    {
      this.feature.value = {
        blogItems: []
      }
    }

    //if value contains blogItems, then loop through each item an if item.type === text, then check if text is HTML or plain text, if plain text then convert it to HTML
    if(this.feature.value.blogItems)
    {
      this.feature.value.blogItems.forEach((item: any) => {
        if(item.type === 'text')
        {
          if(item.value && item.value.indexOf('<') === -1)
          {
            //encapsulate each new line type using regex with <p> tag
            item.value = item.value.split('\n').map((line: any) => `<p>${line}</p>`).join('');
          }
        }
      });
    }

  }

  addBlogItem(type: string) {
    let blogItems = this.feature.value.blogItems ?? [];
    let item = { id: Math.random().toString(36).slice(2, 8), type: type };
    blogItems.push(item);
    this.feature.value = Object.assign({ blogItems: blogItems });
    this.featureChange.emit(this.feature);
  }

  removeBlogItem(item: any) {
    let blogItems = this.feature.value.blogItems ?? [];
    let index = blogItems.indexOf(item, 0);
    if (index > -1) {
      blogItems.splice(index, 1);
    }
    this.feature.value.blogItems = blogItems;
    this.featureChange.emit(this.feature);
    this.updateCharCount();
  }

  blogImageDropped($event: any, item: any) {
    this.addBlogImage($event, item);
  }

  blogImageBrowse(files: any, item: any) {
    this.addBlogImage(files, item);
  }

  getSortableJsOptions() {
    return { onUpdate: () => this.featureChange.emit(this.feature) };
  }

  addBlogImage(files: any, item: any) {
    if (files.length > 0) {
      let file = files[0];
      const url = URL.createObjectURL(file);
      var type = this.getFileType(file);
      if (type.startsWith("image")) {
        if (file.size < this.maxImageSize) {
          if (item.images === undefined) item.images = [];
          item.images.push(Object.assign({ 
            name: file.name, 
            url: url, 
            size: file.size, 
            isUploaded: false, 
            type: type, 
            file: file 
          }));
          this.featureChange.emit(this.feature);
        } else {
          this.messageService.add({ 
            severity: 'error', 
            summary: 'Error', 
            detail: 'Image file size exceeded'
          });
        }
      } else {
        this.messageService.add({ 
          severity: 'error', 
          summary: 'Error', 
          detail: 'Invalid file type.'
        });
      }
    }
  }

  deleteBlogImage(index: number, item: any) {
    item.images.splice(index, 1);
    console.log(item.images.length)
    this.featureChange.emit(this.feature);
  }

  blogWordCounter(event: any) {
    this.updateCharCount();
    if (this.currentChars >= this.maxChars) {
      if (!(event.code == "Backspace" || event.code == "Delete")) 
        return false;
    }
    return true;
  }

  updateCharCount() {
    let blogItems = this.feature.value?.blogItems ?? [];
    let chars = 0;
    blogItems.forEach(item => {
      if (item.type !== "Image") {
        let text = item.value ?? "";
        chars += text.length;
      }
    });
    this.currentChars = chars;
  }

  private getFileType(file: any): string {
    return file.type.split('/')[0];
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.feature.value.blogItems, event.previousIndex, event.currentIndex);
    this.featureChange.emit(this.feature);
  }

  log(test:any)
  {
    console.log(test);
  }
}